import { SwaggerlessContext } from 'Context/SwaggerlessContext';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { displayErrorMessage } from 'Helpers/FacetNotificationManager';
import { withStyles } from '@material-ui/core';
import {
  FDDialogActions,
  FDPrimaryActionButton,
  FDDialog,
  FDDialogContent,
  FDBox,
  FDStack,
  FDTextInput,
  FDDialogTitle,
  FDTextButton, FDStat,
} from '@facet-wealth/design';

const styles = () => ({
  root: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
  input: {
    display: 'flex',
    flex: 1,
  },
});

class RenameModal extends Component {
  constructor(props) {
    super(props);

    this.state = {
      filename: '',
      fileExtension: '',
      isAPIRequestPending: false,
      isFolder: false,
    };

    this.closeModal = this.closeModal.bind(this);
    this.handleFilenameChange = this.handleFilenameChange.bind(this);
    this.handleRenameFile = this.handleRenameFile.bind(this);
  }

  componentDidUpdate(prevProps) {
    // Every time this modal opens for a new file, the state will get updated with the current file name,
    // and that value will be used throughout the component.
    const { isOpen, renameModalFolderItem } = this.props;
    if (!prevProps.isOpen && isOpen) {
      this.setFilename(renameModalFolderItem);
      this.setIsFolder(renameModalFolderItem);
    }
  }

  setFilename(renameModalFolderItem) {
    const splitFilename = renameModalFolderItem?.attributes.name.split('.');
    const fileExtension = splitFilename[splitFilename.length - 1];
    const filename = renameModalFolderItem?.attributes.name.replace(`.${fileExtension}`, '');
    this.setState({ filename, fileExtension });
  }

  setIsFolder(renameModalFolderItem) {
    const value = renameModalFolderItem.type === 'folder';
    this.setState({ isFolder: value });
  }

  closeModal() {
    const { closeModal } = this.props;
    closeModal();
  }

  handleFilenameChange(e) {
    const val = e.target.value;
    this.setState({ filename: val });
  }

  handleRenameFile() {
    const {
      householdId,
      renameModalFolderItem,
      refreshFolder,
      folderID,
      folderName,
    } = this.props;
    const { updateFile } = this.context;
    const { filename, fileExtension, isFolder } = this.state;
    const onSuccess = () => {
      this.closeModal();
      this.setState({ isAPIRequestPending: false });
    };
    const onFail = onSuccess;
    this.setState({ isAPIRequestPending: true });
    let name = filename || renameModalFolderItem.name;
    if (!isFolder) {
      name = filename ? `${filename}.${fileExtension}` : renameModalFolderItem.name;
    }
    updateFile(householdId, renameModalFolderItem.id, {
      type: isFolder ? 'folder' : 'file',
      id: renameModalFolderItem.id,
      attributes: {
        ...renameModalFolderItem.attributes,
        name,
      },
    })
      .then(() => refreshFolder(folderID, folderName, onSuccess, onFail))
      .catch((e) => {
        displayErrorMessage(e, e.response.body.errors);
        onFail();
      }); // TODO: do something more useful
  }

  render() {
    const { isOpen } = this.props;
    const {
      filename, isAPIRequestPending, fileExtension, isFolder,
    } = this.state;

    return (
      <FDDialog
        onClose={this.closeModal}
        open={isOpen}
      >
        <FDDialogTitle value={`Rename ${isFolder ? 'Folder' : 'File'}`} />
        <FDDialogContent>
          <FDBox width={'500px'}>
            <FDStack
              direction="column"
              spacing={2}
            >
              <FDTextInput
                label={`${isFolder ? 'Folder' : 'File'} Name`}
                placeholder={`${isFolder ? 'Folder' : 'File'} Name`}
                onChange={this.handleFilenameChange}
                value={filename}
                error={filename === ''}
                helperText={filename === '' ? `Invalid ${isFolder ? 'folder' : 'file'} name` : ''}
              />
              {!isFolder && (<FDStat value={`.${fileExtension}`} label={'File Extension'} />)}
            </FDStack>
          </FDBox>
        </FDDialogContent>
        <FDDialogActions>
          <FDPrimaryActionButton
            label={'Save'}
            loading={isAPIRequestPending}
            onClick={this.handleRenameFile}
            test="save"
          />
          <FDTextButton
            label={'Cancel'}
            onClick={this.closeModal}
            test="close"
          />
        </FDDialogActions>
      </FDDialog>
    );
  }
}

RenameModal.contextType = SwaggerlessContext;

RenameModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  closeModal: PropTypes.func.isRequired,
  renameModalFolderItem: PropTypes.object,
  refreshFolder: PropTypes.func.isRequired,
  folderID: PropTypes.number.isRequired,
  folderName: PropTypes.string.isRequired,
  householdId: PropTypes.number.isRequired,
};

RenameModal.defaultProps = {
  renameModalFolderItem: {},
};

export default withStyles(styles)(RenameModal);
